
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import Editor from '@/views/stencil/components/editor'
import { getDeScheme } from '../index'

export default {
data() {
return {
currentItem: {
schemeCode: ''
},
left: ['2.3rem', '8.1rem', '14.05rem'],
currentIndex: null
}
},
computed: {

scheme_code() {
return this.$route.query.scheme_code || ''
},
},
created() {
this.currentItem = getDeScheme(this.schemes, this.scheme_code);
},
props: {
schemes: {
type: Array,
default: () => {
return []
}
},
commodityName: {
type: String,
default: ''
},

},
components: {
Tab,
TabItem,
Editor
},
methods: {
handler(item) {
this.currentItem = item
this.$emit('changeScheme', this.currentItem)

},
},
}
